import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

export const contactApi = {
  submit: async (payload) => {
    const res = await axios.post(`${API_BASE_URL}/contact`, payload);
    return res.data;
  },
};
